const GPT_REALTIME_2_LIVEKIT_FLAG = "gpt_realtime_2";
function isGptRealtime2LivekitFlag(flag) {
  return flag === GPT_REALTIME_2_LIVEKIT_FLAG || flag.startsWith(`${GPT_REALTIME_2_LIVEKIT_FLAG}:`);
}
const GPT_REALTIME_2_MODELS = [
  "gpt-realtime-2",
  "gpt-realtime-2.1",
  "gpt-realtime-2.1-mini"
];
const GPT_REALTIME_2_EAGERNESS_OPTIONS = [
  "auto",
  "low",
  "medium",
  "high"
];
const GPT_REALTIME_2_NOISE_REDUCTION_OPTIONS = [
  "near_field",
  "far_field",
  "none"
];
const GPT_REALTIME_2_REASONING_EFFORT_OPTIONS = [
  "minimal",
  "low",
  "medium",
  "high",
  "xhigh",
  "none"
];
const DEFAULT_GPT_REALTIME_2_CONFIG = {
  model: "gpt-realtime-2",
  voice: "marin",
  eagerness: "medium",
  speed: "1.0",
  noiseReduction: "far_field",
  reasoningEffort: "minimal"
};
const GPT_REALTIME_2_SPEED_MIN = 0.25;
const GPT_REALTIME_2_SPEED_MAX = 1.5;
function parseGptRealtime2Config(livekitAgentFlags) {
  const flag = livekitAgentFlags.find(isGptRealtime2LivekitFlag);
  if (!flag) {
    return null;
  }
  const config = { ...DEFAULT_GPT_REALTIME_2_CONFIG };
  if (flag === GPT_REALTIME_2_LIVEKIT_FLAG) {
    return config;
  }
  const serializedConfig = flag.slice(`${GPT_REALTIME_2_LIVEKIT_FLAG}:`.length);
  for (const pair of serializedConfig.split(",")) {
    const separatorIndex = pair.indexOf("=");
    if (separatorIndex === -1) {
      continue;
    }
    const key = pair.slice(0, separatorIndex).trim();
    const value = pair.slice(separatorIndex + 1).trim();
    if (!value) {
      continue;
    }
    switch (key) {
      case "model":
        if (isOneOf(GPT_REALTIME_2_MODELS, value)) {
          config.model = value;
        }
        break;
      case "voice":
        config.voice = value;
        break;
      case "eagerness": {
        const eagerness = value.toLowerCase();
        if (isOneOf(GPT_REALTIME_2_EAGERNESS_OPTIONS, eagerness)) {
          config.eagerness = eagerness;
        }
        break;
      }
      case "speed":
        if (isValidGptRealtime2Speed(value)) {
          config.speed = formatGptRealtime2Speed(value);
        }
        break;
      case "noise_reduction": {
        const noiseReduction = normalizeDisabledValue(value);
        if (isOneOf(GPT_REALTIME_2_NOISE_REDUCTION_OPTIONS, noiseReduction)) {
          config.noiseReduction = noiseReduction;
        }
        break;
      }
      case "reasoning_effort": {
        const reasoningEffort = normalizeDisabledValue(value);
        if (isOneOf(GPT_REALTIME_2_REASONING_EFFORT_OPTIONS, reasoningEffort)) {
          config.reasoningEffort = reasoningEffort;
        }
        break;
      }
    }
  }
  return config;
}
function normalizeDisabledValue(value) {
  const normalized = value.toLowerCase();
  return normalized === "off" || normalized === "disabled" || normalized === "default" ? "none" : normalized;
}
function isValidGptRealtime2Speed(speed) {
  const numericSpeed = Number(speed);
  return numericSpeed >= GPT_REALTIME_2_SPEED_MIN && numericSpeed <= GPT_REALTIME_2_SPEED_MAX;
}
function formatGptRealtime2Speed(speed) {
  const numericSpeed = Number(speed);
  return Number.isInteger(numericSpeed) ? numericSpeed.toFixed(1) : String(numericSpeed);
}
function isOneOf(options, value) {
  return options.includes(value);
}
const LIVEKIT_NOISE_CANCELLATION_FLAG = "livekit_noise_cancellation";
const LIVEKIT_NOISE_CANCELLATION_MODES = [
  "none",
  "krisp_bvc",
  "krisp_bvc_telephony",
  "ai_coustics_quail_vf_s",
  "ai_coustics_quail_vf_l"
];
function isLivekitNoiseCancellationFlag(flag) {
  return flag === LIVEKIT_NOISE_CANCELLATION_FLAG || flag.startsWith(`${LIVEKIT_NOISE_CANCELLATION_FLAG}=`) || flag.startsWith(`${LIVEKIT_NOISE_CANCELLATION_FLAG}:`);
}
function getLivekitNoiseCancellationMode(livekitAgentFlags) {
  const flag = livekitAgentFlags.find(isLivekitNoiseCancellationFlag);
  if (!flag || flag === LIVEKIT_NOISE_CANCELLATION_FLAG) {
    return "none";
  }
  const separator = flag.startsWith(`${LIVEKIT_NOISE_CANCELLATION_FLAG}=`) ? "=" : ":";
  const rawMode = flag.slice(`${LIVEKIT_NOISE_CANCELLATION_FLAG}${separator}`.length).trim().toLowerCase().replace(/-/g, "_");
  if (rawMode === "off" || rawMode === "disabled") {
    return "none";
  }
  return isLivekitNoiseCancellationMode(rawMode) ? rawMode : "none";
}
function isLivekitNoiseCancellationMode(value) {
  return LIVEKIT_NOISE_CANCELLATION_MODES.includes(
    value
  );
}
function hasGptRealtime2VoiceStack(livekitAgentFlags) {
  return livekitAgentFlags.some(isGptRealtime2LivekitFlag);
}
const ELEVENLABS_TTS_LIVEKIT_FLAG = "eleven_flash_v2_5";
function checkIsElevenlabsTtsLivekitFlag(flag) {
  return flag === ELEVENLABS_TTS_LIVEKIT_FLAG || flag.startsWith(`${ELEVENLABS_TTS_LIVEKIT_FLAG}:`);
}
const DEFAULT_VOICE_STACK_LIVEKIT_FLAG = "voice_stack=default";
function checkIsVoiceStackLivekitFlag(flag) {
  return flag === DEFAULT_VOICE_STACK_LIVEKIT_FLAG || isGptRealtime2LivekitFlag(flag) || checkIsElevenlabsTtsLivekitFlag(flag);
}
const LIVEKIT_MAX_SESSION_SECONDS = 60 * 60;
const AWAY_SHUTDOWN_TIMEOUT_WAIT_FOR_USER_SETTING = {
  flagName: "away_shutdown_timeout_wait_for_user",
  defaultSeconds: 10 * 60,
  minSeconds: 60,
  maxSeconds: LIVEKIT_MAX_SESSION_SECONDS
};
const LIVEKIT_TIMEOUT_SETTINGS = [
  AWAY_SHUTDOWN_TIMEOUT_WAIT_FOR_USER_SETTING
];
function checkIsLivekitTimeoutFlag(setting, flag) {
  return flag === setting.flagName || flag.startsWith(`${setting.flagName}=`);
}
function checkIsValidLivekitTimeoutSeconds(setting, seconds) {
  return Number.isInteger(seconds) && seconds >= setting.minSeconds && seconds <= setting.maxSeconds;
}
function parseLivekitTimeoutSeconds(setting, livekitAgentFlags) {
  const flag = livekitAgentFlags.find(
    (candidate) => checkIsLivekitTimeoutFlag(setting, candidate)
  );
  if (!flag) {
    return null;
  }
  const seconds = Number(flag.slice(`${setting.flagName}=`.length));
  return checkIsValidLivekitTimeoutSeconds(setting, seconds) ? seconds : null;
}
function buildLivekitTimeoutFlag(setting, seconds) {
  return `${setting.flagName}=${seconds.toString()}`;
}
const LIVEKIT_AGENT_FLAG_SETTINGS = [
  checkIsVoiceStackLivekitFlag,
  isLivekitNoiseCancellationFlag,
  ...LIVEKIT_TIMEOUT_SETTINGS.map(
    (setting) => (flag) => checkIsLivekitTimeoutFlag(setting, flag)
  )
];
function resolveTeammateAgentLivekitAgentFlags(companyFlags, agentFlags) {
  const overriddenSettings = LIVEKIT_AGENT_FLAG_SETTINGS.filter(
    (checkBelongsToSetting) => agentFlags.some(checkBelongsToSetting)
  );
  const inheritedFlags = companyFlags.filter(
    (flag) => !overriddenSettings.some(
      (checkBelongsToSetting) => checkBelongsToSetting(flag)
    )
  );
  const flags = /* @__PURE__ */ new Set([...inheritedFlags, ...agentFlags]);
  flags.delete(DEFAULT_VOICE_STACK_LIVEKIT_FLAG);
  return [...flags];
}
export {
  AWAY_SHUTDOWN_TIMEOUT_WAIT_FOR_USER_SETTING,
  DEFAULT_GPT_REALTIME_2_CONFIG,
  DEFAULT_VOICE_STACK_LIVEKIT_FLAG,
  ELEVENLABS_TTS_LIVEKIT_FLAG,
  GPT_REALTIME_2_EAGERNESS_OPTIONS,
  GPT_REALTIME_2_LIVEKIT_FLAG,
  GPT_REALTIME_2_MODELS,
  GPT_REALTIME_2_NOISE_REDUCTION_OPTIONS,
  GPT_REALTIME_2_REASONING_EFFORT_OPTIONS,
  LIVEKIT_NOISE_CANCELLATION_FLAG,
  LIVEKIT_NOISE_CANCELLATION_MODES,
  buildLivekitTimeoutFlag,
  checkIsElevenlabsTtsLivekitFlag,
  checkIsLivekitTimeoutFlag,
  checkIsValidLivekitTimeoutSeconds,
  checkIsVoiceStackLivekitFlag,
  formatGptRealtime2Speed,
  getLivekitNoiseCancellationMode,
  hasGptRealtime2VoiceStack,
  isGptRealtime2LivekitFlag,
  isLivekitNoiseCancellationFlag,
  isValidGptRealtime2Speed,
  parseGptRealtime2Config,
  parseLivekitTimeoutSeconds,
  resolveTeammateAgentLivekitAgentFlags
};
//# sourceMappingURL=livekitAgentFlags.js.map
